export default "__VITE_ASSET__wFwEiOPv__"